import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import Layout from '../components/Layout';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const AdminKredietchecksPage: React.FC = () => {
  const navigate = useNavigate();
  const { accessToken, isAuthenticated } = useAuthStore();
  const headers = { Authorization: `Bearer ${accessToken}` };
  const [d, setD] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API_BASE_URL}/api/admin/kredietchecks-overzicht`, { headers });
      setD(r.ok ? await r.json() : null);
    } finally { setLoading(false); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);

  useEffect(() => {
    if (!isAuthenticated || !accessToken) { navigate('/login'); return; }
    load();
  }, [isAuthenticated, accessToken, navigate, load]);

  if (loading) return <Layout><div className="text-center py-12 text-slate-500">Laden...</div></Layout>;
  if (!d) return <Layout><div className="text-center py-12 text-slate-500">Geen gegevens.</div></Layout>;

  return (
    <Layout>
      <p className="text-sm text-slate-500 mb-6">
        Afgenomen kredietchecks (grades) bij Allianz Trade. Eén contractnummer voor álle collectieven — hier gescheiden per niveau.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
        <div className="rounded-xl border border-mfb-blue/20 bg-mfb-blue/5 p-5">
          <div className="text-3xl font-display font-bold text-mfb-blue tabular-nums">{d.totaal_allianz}</div>
          <div className="text-xs font-medium text-slate-600 mt-1">Totaal afgenomen bij Allianz Trade</div>
          <div className="text-xs text-slate-400 mt-1">Contract: {d.contractnummer || '— niet ingesteld —'}</div>
        </div>
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-5">
          <div className="text-3xl font-display font-bold text-slate-700 tabular-nums">{d.per_collectief.length}</div>
          <div className="text-xs font-medium text-slate-600 mt-1">Collectieven met afname</div>
        </div>
        <div className="rounded-xl border border-amber-200 bg-amber-50 p-5">
          <div className="text-3xl font-display font-bold text-amber-700 tabular-nums">{d.totaal_niet_gevonden}</div>
          <div className="text-xs font-medium text-slate-600 mt-1">Niet gevonden (geen afrekening)</div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
          <div className="px-5 py-3 border-b border-slate-200 font-display font-semibold text-mfb-blue">Per collectief</div>
          <table className="min-w-full divide-y divide-slate-200 text-sm">
            <thead className="bg-slate-50"><tr>
              <th className="px-5 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Collectief</th>
              <th className="px-5 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Polisnummer</th>
              <th className="px-5 py-2 text-right text-xs font-semibold text-slate-500 uppercase">Afgenomen</th>
            </tr></thead>
            <tbody className="divide-y divide-slate-100">
              {d.per_collectief.map((c: any) => (
                <tr key={c.collectiviteit} className="hover:bg-slate-50">
                  <td className="px-5 py-2 font-medium text-mfb-blue">{c.collectiviteit}</td>
                  <td className="px-5 py-2 text-slate-600">{c.polisnummer || '—'}</td>
                  <td className="px-5 py-2 text-right tabular-nums text-slate-700">{c.aantal}</td>
                </tr>
              ))}
              {d.per_collectief.length === 0 && <tr><td colSpan={3} className="px-5 py-4 text-slate-400">Nog geen afname.</td></tr>}
            </tbody>
          </table>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
          <div className="px-5 py-3 border-b border-slate-200 font-display font-semibold text-mfb-blue">Per lid</div>
          <table className="min-w-full divide-y divide-slate-200 text-sm">
            <thead className="bg-slate-50"><tr>
              <th className="px-5 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Lid</th>
              <th className="px-5 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Subnummer</th>
              <th className="px-5 py-2 text-right text-xs font-semibold text-slate-500 uppercase">Afgenomen</th>
            </tr></thead>
            <tbody className="divide-y divide-slate-100">
              {d.per_lid.map((m: any, i: number) => (
                <tr key={i} className="hover:bg-slate-50">
                  <td className="px-5 py-2 font-medium text-slate-700">{m.lid}<div className="text-xs text-slate-400">{m.collectiviteit}</div></td>
                  <td className="px-5 py-2 text-slate-600">{m.polis_subnummer || '—'}</td>
                  <td className="px-5 py-2 text-right tabular-nums text-slate-700">{m.aantal}</td>
                </tr>
              ))}
              {d.per_lid.length === 0 && <tr><td colSpan={3} className="px-5 py-4 text-slate-400">Nog geen afname.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default AdminKredietchecksPage;
